import React, { Component } from 'react';
import './index.less';
import Footer from "../../components/Footer";
import Nav from '../../components/Nav/index';
import { message } from "antd";
import Loader from '../../components/loader';
import A from '../../assets/img/svg/a.svg';
import B from '../../assets/img/svg/b.svg';
import C from '../../assets/img/svg/c.svg';
import D from '../../assets/img/svg/d.svg';
import E from '../../assets/img/svg/e.svg';
import F from '../../assets/img/svg/f.svg';
import G from '../../assets/img/svg/g.svg';
import H from '../../assets/img/svg/h.svg';
import I from '../../assets/img/svg/i.svg';
import J from '../../assets/img/svg/j.svg';
import K from '../../assets/img/svg/k.svg';
import L from '../../assets/img/svg/l.svg';
import M from '../../assets/img/svg/m.svg';
import N from '../../assets/img/svg/n.svg';
import O from '../../assets/img/svg/o.svg';
import P from '../../assets/img/svg/p.svg';
import Q from '../../assets/img/svg/q.svg';
import R from '../../assets/img/svg/r.svg';
import S from '../../assets/img/svg/s.svg';
import T from '../../assets/img/svg/t.svg';
import U from '../../assets/img/svg/u.svg';
import V from '../../assets/img/svg/v.svg';
import W from '../../assets/img/svg/w.svg';
import X from '../../assets/img/svg/x.svg';
import Y from '../../assets/img/svg/y.svg';
import Z from '../../assets/img/svg/z.svg';
import arrow from '../../assets/img/arrow_left.png';
import bg from '../../assets/img/bj_pro.png';
import Vivus from 'vivus';
import Axios from "../../axios";
import Utils from "../../utils/utils";
import history from "../../history";
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import anime from "animejs";
import {withRouter} from "react-router-dom";
import $ from 'jquery';
const rdom = require('react-dom');
class Pro extends Component{
    constructor(props){
        super(props);
        this.state={
            wordP:'',
            isLoading:true,
            show: false,
            time:null,
            bgImg:bg,
            initBg:bg
        }
    }

    componentWillMount() {
        let id = this.props.match.params.id;
        sessionStorage.setItem('proId',id);
        this.listRequest(id);//数据请求
        var textWrapper = document.querySelector('.sub-title');
        console.log(textWrapper)
    }
    componentDidMount() {
        console.log(this.state.bgImg)
        if(this.state.bgImg){
            console.log('22222')
        }
       /* var options1 = {
            id: 'sub-title'
        };*/
        var option = document.getElementsByClassName("sub-title");
        // $('.box1').initReveal(options1);
        if (document.addEventListener) {
            document.addEventListener('DOMMouseScroll', this.scrollFunc.bind(this), false);
        }
        window.onmousewheel = document.onmousewheel = this.scrollFunc.bind(this);
    }
    //
    //鼠标移上去
    async handleMouse(e, id, picUrl){
        let target = e.target;
        var canvas = document.getElementById('myCanvas');
        var img = document.getElementById('imgs');
        console.log(img.src)
        // let imgColor = Utils.getImageColor(canvas, img.src);
        let mask = document.getElementsByClassName('wrap-mask')[0];
        Utils.getImageColor(picUrl,function (bgcolor) {
            let bgColor = bgcolor[0];
            anime.timeline({loop: 1})
                .add({
                    targets: '.wrap-mask',
                    opacity: [0,1],
                    easing: "linear",
                    duration: 500,
                })
            mask.style.backgroundColor=bgColor;
        });

        // proItems.map((item, i) => {
        //     if (item.id === id) {
        //         item.isActive = true;
        //         let obj = item;
        //         // proItems.splice(i,1);// 第i位删除1项
        //         // proItems.unshift(obj);
        //         this.setState({
        //             pro_title:item.title,
        //             pro_dec:item.description
        //         })
        //     }else{
        //         item.isActive=false;
        //     }
        // })
        this.setState({
            bgImg: picUrl
        })
       /* target.onmouseleave = () => {
            anime.timeline({loop: 1})
                // .add({
                //     targets: target,
                //     scale:[1.02,1],
                //     easing: "linear",
                //     duration: 100,
                //     update:()=>{
                //         target.style.color = '#fff';
                //         mask.style.backgroundColor='rgba(0,0,0,0.4)';
                //     }
                // })
                .add({
                    targets: '.wrap-mask',
                    opacity: [1,0],
                    easing: "linear",
                    duration: 500,
                })
            this.setState({
                // proItems,
                bgImg: ''
            })
        }*/

    }
    //鼠标移开
    leaveHandle = (e) => {
        console.log(e)
        let target = e.target;
        let mask = document.getElementsByClassName('wrap-mask')[0];
        anime.timeline({loop: 1})
            .add({
                targets: target,
                scale:[1.02,1],
                easing: "linear",
                duration: 100,
                update:()=>{
                    // target.style.color = '#fff';
                    mask.style.backgroundColor='rgba(0,0,0,0.4)';
                }
            })
            .add({
                targets: '.wrap-mask',
                opacity: [1,0],
                easing: "linear",
                duration: 500,
            })
        this.setState({
            bgImg: ''
        })
    }
    //鼠标滚动事件
    handleScroll(e) {
        const ele = rdom.findDOMNode(this);
        // console.log(ele)
        var eleInfo = document.getElementsByClassName('pro-info')[0];
        var height = eleInfo.style.height, display = false, timer;
        height = parseInt(height);
        var step1 = function(){
            if(height<50){
                height+=5;
            }else{
                height=50;
            }
            eleInfo.style.height = height + "vh";
            eleInfo.style.opacity = 1;
            if (height > 0 && height < 50) {
                timer = setTimeout(step1, 30);
            }
        }
        var step2 = function(){
            if(height>0){
                height-=5;
            }else{
                height=0;
            }
            eleInfo.style.height = height + "vh";
            eleInfo.style.opacity = 0;
            if (height > 0 && height < 50) {
                timer = setTimeout(step2, 30);
            }
        }
        if (e.nativeEvent.deltaY <= 0) {
            /* scrolling up */
            if (ele.scrollTop <= 0) {
                e.preventDefault();
                // if(!this.state.isMove){
                //     anime.timeline({loop: 1})
                //         .add({
                //             targets: '.first-tip',
                //             translateY: ['22em',0],
                //             translateZ: 0,
                //             opacity:[0,1],
                //             easing: "easeOutExpo",
                //             duration: 500,
                //         })
                //     this.setState({
                //         isMove:true
                //     })
                // }
                // eleInfo.style.height = 50+'vh';

                // if (timer) clearTimeout(timer);
                // step1();
            }
        } else {
            /* scrolling down */
            // if (timer) clearTimeout(timer);
            // step2();
            if(this.state.isMove){
                anime.timeline({loop: 1})
                    .add({
                        targets: '.first-tip',
                        translateY: [0, '22em'],
                        translateZ: 0,
                        opacity:[1,0],
                        easing: "easeOutExpo",
                        duration: 500,
                    })
                this.setState({
                    isMove:false
                })
            }
            eleInfo.style.height = 0+'vh';
            if (ele.scrollTop + ele.clientHeight >= ele.scrollHeight) {
                e.preventDefault();
            }
        }
    }
    scrollFunc= (e) =>{
        e = e || window.event;
        var eleInfo = document.getElementsByClassName('pro-info')[0];
        var height = eleInfo.style.height, display = false, timer;
        height = parseInt(height);
        var step1 = function(){
            if(height<50){
                height+=5;
            }else{
                height=50;
            }
            eleInfo.style.height = height + "vh";
            eleInfo.style.opacity = 1;
            if (height > 0 && height < 50) {
                timer = setTimeout(step1, 30);
            }
        }
        var step2 = function(){
            if(height>0){
                height-=5;
            }else{
                height=0;
            }
            eleInfo.style.height = height + "vh";
            eleInfo.style.opacity = 0;
            if (height > 0 && height < 50) {
                timer = setTimeout(step2, 30);
            }
        }
      /*  console.log(e.wheelDelta)
        console.log(e.detail)*/
        if (e.wheelDelta) { //第一步：先判断浏览器IE，谷歌滑轮事件
            if (e.wheelDelta > 0) { //当滑轮向上滚动时
                //   console.log("滑轮向上滚动");
            }
            if (e.wheelDelta < 0) { //当滑轮向下滚动时
                  console.log("滑轮向下滚动");
                if(this.state.isMove){
                    anime.timeline({loop: 1})
                        .add({
                            targets: '.first-tip',
                            translateY: [0, '22em'],
                            translateZ: 0,
                            opacity:[1,0],
                            easing: "easeOutExpo",
                            duration: 500,
                        })
                    this.setState({
                        isMove:false
                    })
                }
                eleInfo.style.height = 0+'vh';
            }
        } else if (e.detail) { //Firefox滑轮事件
            if (e.detail> 0) { //当滑轮向上滚动时
                  // console.log("滑轮向下滚动");
                if(this.state.isMove){
                    anime.timeline({loop: 1})
                        .add({
                            targets: '.first-tip',
                            translateY: [0, '22em'],
                            translateZ: 0,
                            opacity:[1,0],
                            easing: "easeOutExpo",
                            duration: 500,
                        })
                    this.setState({
                        isMove:false
                    })
                }
                eleInfo.style.height = 0+'vh';
            }
            if (e.detail< 0) { //当滑轮向下滚动时
                  // console.log("滑轮向下上滚动");
               /* if(this.state.isMove){
                    anime.timeline({loop: 1})
                        .add({
                            targets: '.first-tip',
                            translateY: [0, '22em'],
                            translateZ: 0,
                            opacity:[1,0],
                            easing: "easeOutExpo",
                            duration: 500,
                        })
                    this.setState({
                        isMove:false
                    })
                }
                eleInfo.style.height = 0+'vh';*/
            }
        }
    }
    //点击查看详情
    clickPro = (e, id, excerpt) => {
        console.log(id)
        this.detailRequest(id, excerpt);
    }
    //详情
    async detailRequest(id, excerpt) {
        console.log(excerpt)
        let current = await this.showWord(excerpt);
        let curIndex = 0;
        let curItem = null;
        let proItems = this.state.proItems.map((item,index)=>{
            item.isActive = false;
            if(item.id == id){
                curIndex = index;
                curItem = item;
            }
            return item;
        })
        proItems.splice(curIndex,1);
        proItems.unshift(curItem);
        proItems[0].isActive = true;
        this.setState({proItems})
        if (current) {
            console.log('1111')
            document.getElementById("my-svg").innerHTML = "";
            new Vivus('my-svg', {duration: 200, file: this.state.imgWord}, ()=>{
                // window.location.href = `/prDetail/${id}`;
                this.props.history.push(`/prDetail/${id}`);
                console.log('2222')
                // history.push(`/prDetail/${id}`);
            })
        }
    }
    /*列表数据请求*/
    listRequest = (id) => {
        let _this = this;
        var params = { type: 'Products',category:id,page:1,max:100};
        this.setState({
            isLoading: true
        })
        Axios.get({
            block: '/api',
            url: '/post/merge',
            params: params,
        }).then((data) => {
            console.log(data)
            if (data.code === 0) {
                let proItems = [];
                let items = data.data;
                for (let i in items) {
                    let item = items[i];
                    let type = item.categories[0];
                    console.log(type)
                    item.id = item.post.id;
                    item.title = item.post.title;
                    let meta = item.metas[0].value;
                    let _meta = JSON.parse(meta);
                    let mPics=[];
                    console.log(_meta)
                    _meta.map((item,index)=>{
                        item.showurl = Utils.getUrl(item.showurl);
                        mPics.push(item.showurl);
                    })
                    item.metas = mPics;
                    let proP = JSON.parse(meta)[0];
                    let _pic = proP.showurl;
                    item.meta = JSON.parse(meta);
                    item.picUrl = Utils.getUrl(_pic);
                    item.isActive = false;
                    item.excerpt = item.post.excerpt;
                    this.showWord(items[0].post.excerpt);
                    console.log(_pic)
                    console.log(item)
                    // item.title = item[0].title;
                    // let meta = items[i].metas[0].value;
                    // let _meta = JSON.parse(meta);
                    // let mPics=[];
                    // console.log(_meta)
                    // _meta.map((item,index)=>{
                    //     item.showurl = Utils.getUrl(item.showurl);
                    //     mPics.push(item.showurl);
                    // })
                    // // let proP=JSON.parse(meta)[0];
                    // item.meta = mPics;
                    // let proP = JSON.parse(meta)[0];
                    // let _pic = proP.showurl;
                    // item.meta = JSON.parse(meta);
                    // item.picUrl = Utils.getUrl(_pic);
                    // item.isActive = false;
                    // this.showWord(items[0].post.excerpt);
                    if (i == 0) {
                        // item.isActive = true;
                        this.setState({
                            // bgImg:Utils.getUrl(_pic),
                            pro_title:item.post.title,
                            pro_dec:item.post.description
                        })
                    }
                    proItems.push(item);
                    console.log(proItems)
                }
                sessionStorage.setItem('proItems', JSON.stringify(proItems));
                this.setState({
                    proItems
                })
            } else {
                message.error(data.msg)
            }
            // this.setState({
            //     isLoading: false
            // })

            setTimeout( () =>{
                this.setState({
                    isLoading: false
                },()=>{
                    this.animation();
                })
            },1000)
            // this.animation();
        }).catch((error) => {
            console.log(error);
        })
    };
    animation = () => {
        new Vivus('my-svg', {duration: 200, file: this.state.imgWord}, ()=>{})
        // var vivus = new Vivus('my-svg', {duration: 200, file: this.state.imgWord}, {})
    }
    async showWord(excerpt) {
        let _word = '';
        // console.log(excerpt)
        if (excerpt == 'A') {
            _word = A;
        }
        if (excerpt == 'B') {
            _word = B;
        }
        if (excerpt == 'C') {
            _word = C;
        }
        if (excerpt == 'D') {
            _word = D;
        }
        if (excerpt == 'E') {
            _word = E;
        }
        if (excerpt == 'F') {
            _word = F;
        }
        if (excerpt == 'G') {
            _word = G;
        }
        if (excerpt == 'H') {
            _word = H;
        }
        if (excerpt == 'I') {
            _word = I;
        }
        if (excerpt == 'J') {
            _word = J;
        }
        if (excerpt == 'K') {
            _word = K;
        }
        if (excerpt == 'L') {
            _word = L;
        }
        if (excerpt == 'M') {
            _word = M;
        }
        if (excerpt == 'N') {
            _word = N;
        }
        if (excerpt == 'O') {
            _word = O;
        }
        if (excerpt == 'P') {
            _word = P;
        }
        if (excerpt == 'Q') {
            _word = Q;
        }
        if (excerpt == 'R') {
            _word = R;
        }
        if (excerpt == 'S') {
            _word = S;
        }
        if (excerpt == 'T') {
            _word = T;
        }
        if (excerpt == 'U') {
            _word = U;
        }
        if (excerpt == 'V') {
            _word = V;
        }
        if (excerpt == 'W') {
            _word = W;
        }
        if (excerpt == 'X') {
            _word = X;
        }
        if (excerpt == 'Y') {
            _word = Y;
        }
        if (excerpt == 'Z') {
            _word = Z;
        }
        this.setState({
            imgWord: _word
        })
        return _word;
        // console.log(_word)
        // const myVivus = new Vivus('my-svg',{
        //     animationTimingFunction: Vivus.EASE_IN_BOUNCE
        // });
        // myVivus.play(2);

    }
    render() {
        // const styles = {
        //     fontFamily: 'Menlo-Regular, Menlo, monospace',
        //     fontSize: 14,
        //     lineHeight: '10px',
        //     color: 'white',
        //     display: 'flex', alignItems: 'center', justifyContent: 'center'
        // }
        const { proItems, bgImg, wordP, imgWord, isLoading, pro_title, pro_dec, maskColor, initBg } = this.state;
        return (
            <div style={{overflow: 'hidden'}} >
                {isLoading ? <Loader cTitle="产品" eTitle="PRODUCT" />
                    : <div className="pro" >
                        <header className="header-title">
                            <h1 className="white">
                                <a href="/product">
                                    <p className="back-txt">return</p>
                                    <img src={arrow} className="back-icon" width="24" alt="arrow" />
                                </a>
                            </h1>
                        </header>
                        <div className="head-pic">
                            <div className="pro-name">
                                {/*<object id="my-svg" type="image/svg+xml" data={imgWord} width="300" height="300"></object>*/}
                                <div id="my-svg" style={{width:'20em',height:"20em"}}></div>
                            </div>
                        </div>
                        {/*<div onWheel={(e) => this.handleScroll(e)}>*/}
                        <div>
                            <div className="pro-info" style={{ height: '60vh' }}>
                                <div className="info-exp first-tip">
                                    <div className="left">
                                        <h4 className="sub-title">
                                            <Zoom cascade>
                                                {pro_title}
                                            </Zoom>
                                        </h4>
                                    </div>
                                    {/*<h4 className="left letters">Projects Main</h4>*/}
                                    <Fade bottom delay={1000}>
                                        <p className="right cent-box">
                                            {pro_dec}
                                        </p>
                                    </Fade>
                                </div>
                            </div>

                            <div className="pro-cent" style={{ backgroundImage: "url(" + (bgImg?bgImg:initBg) + ")" }}>
                                <div className="wrap-mask" style={{ width: '100vw', height: '100%',backgroundColor:maskColor }}>
                                </div>
                                    <div id="handler">
                                        <div className="" style={{ display: 'none' }}>
                                            <canvas id="myCanvas"></canvas>
                                            <img id="imgs" src={bgImg} alt="img_color" />
                                        </div>
                                        <div className="projects-wrapper"  onMouseLeave ={(e)=>this.leaveHandle(e)}>
                                            {
                                                proItems ? proItems.map((item, index) => {
                                                    return (
                                                        <div className="projects" key={index}>
                                                            <div className="project">
                                                                <a href='javascript:void(0)' onClick={(e) => this.clickPro(e, item.id, item.excerpt)} onMouseOver={(e) => this.handleMouse(e, item.id, item.picUrl)} >
                                                                <span className="wr">
                                                                    {
                                                                        item.isActive ? <span className="txt active" data-id={item.id}>{item.title}</span>
                                                                            : <span className="txt" data-id={item.id}>{item.title}</span>
                                                                    }
                                                                </span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )
                                                }) : ''
                                            }
                                        </div>
                                    </div>

                            </div>
                             {/*<Nav/>*/}
                        </div>
                        </div>

                        // <div onWheel={(e) => this.handleScroll(e)}>
                        //
                        // </div>


                }
                <Footer/>
            </div>
        )
    }
}
export default withRouter(Pro);
